import { clampCreditUsagePercent } from '../../../data/query/credit-allowance.utils';

/** Complimentary cycles show Unlimited only once display_limit usage hits 100%. */
export function shouldShowComplimentaryUnlimitedLabel(
  isComplimentaryUsage: boolean,
  usagePercent: number
): boolean {
  return isComplimentaryUsage && clampCreditUsagePercent(usagePercent) >= 100;
}
